import { render, staticRenderFns } from "./PeopleCountNoKidsDashboardItem.vue?vue&type=template&id=16418b1a&scoped=true"
import script from "./PeopleCountNoKidsDashboardItem.vue?vue&type=script&lang=js"
export * from "./PeopleCountNoKidsDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./PeopleCountNoKidsDashboardItem.vue?vue&type=style&index=0&id=16418b1a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16418b1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16418b1a')) {
      api.createRecord('16418b1a', component.options)
    } else {
      api.reload('16418b1a', component.options)
    }
    module.hot.accept("./PeopleCountNoKidsDashboardItem.vue?vue&type=template&id=16418b1a&scoped=true", function () {
      api.rerender('16418b1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/PeopleCountNoKidsDashboardItem.vue"
export default component.exports